import getTenant, { type MinimumTenant } from '@niarab2c/frontend-commons/src/util/getTenant';
import { setGlobalLocale } from '@niaratech/niara-js-commons';
import loadStorefront from './util/loadStorefront';
const currentScriptSrc = document.currentScript?.['src'];
const CANARY_SCRIPT = 'https://canary.otabuilder.com/static/js/index.js';
const CANARY_SCRIPT_2 = 'https://canary.otabuilder.com/static/js/index2.js';
const main = async () => {
  function loadJS(url, location) {
    const scriptTag = document.createElement('script');
    scriptTag.src = url;
    scriptTag.crossOrigin = 'anonymous';
    scriptTag.defer = true;
    scriptTag.async = true;
    location.appendChild(scriptTag);
  }
  if (currentScriptSrc == CANARY_SCRIPT) {
    loadJS(CANARY_SCRIPT_2, document.body);
    return;
  }
  const locale = localStorage.getItem('locale');
  if (locale) {
    setGlobalLocale(locale);
  }

  // carrega o tenant.canary
  loadStorefront().then(([storefront]) => {
    if (storefront) {
      const tenantIdOrAlias = storefront.tenantId;
      getTenant(tenantIdOrAlias).then((tenant: MinimumTenant) => {
        if (tenant?.canaryStartDate && tenant?.canaryEndDate) {
          const currentDate = new Date().toISOString();
          if (currentDate >= tenant.canaryStartDate && currentDate <= tenant.canaryEndDate) {
            loadJS(CANARY_SCRIPT, document.body);
          }
        } else if (process.env.WEBPACK_SERVE) {
          import('./index2');
          return;
        } else {
          loadJS('/static/js/index2.js', document.body);
          return;
        }
      });
    } else if (process.env.WEBPACK_SERVE) {
      import('./index2');
      return;
    } else {
      loadJS('/static/js/index2.js', document.body);
      return;
    }
  });
};
main();